<script lang="ts" setup>
import type { FieldData } from '~~/server/api/forms/form'

export interface FormKitCustomTextarea {
    data: FieldData
}

const props = defineProps<FormKitCustomTextarea>()
const model = ref<string>('')
const maxLength = 7000
const charactesLeft = computed<number>(() =>
    Math.max(0, maxLength - model.value.length)
)
</script>
<template>
  <div class="position-relative">
    <FormKit
      v-model="model"
      :label="props.data.label"
      :help="props.data.help"
      :name="props.data.name"
      :placeholder="props.data.placeholder"
      :validation="props.data.validations"
      :validation-messages="{
        required: props.data.validation_messages?.['required'] || $t('Vaša správa je povinný údaj'),
      }"
      :value="props.data.defaultValue"
      :maxlength="maxLength"
      type="textarea"
    />
    <small
      class="formkit-characters-count position-absolute top-0 end-0 mt-2 me-2 rounded-3 p-1 fs-xsmall text-white bg-secondary"
    >
      {{ charactesLeft }}
    </small>
  </div>
</template>
